import { render, staticRenderFns } from "./MsgContent.vue?vue&type=template&id=afeb8dc4&scoped=true&"
import script from "./MsgContent.vue?vue&type=script&lang=js&"
export * from "./MsgContent.vue?vue&type=script&lang=js&"
import style0 from "./MsgContent.vue?vue&type=style&index=0&id=afeb8dc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeb8dc4",
  null
  
)

export default component.exports